import { useState } from 'react';
import BannerStep from './BannerStep';
import { BannerSteps } from './BannerSteps';
import SwipeableViews from 'react-swipeable-views';
import { PaginationDots } from 'components/shared/PaginationDots/PaginationDots';
import { autoPlay } from 'react-swipeable-views-utils';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

export const AuthCarousel = () => {
    const [activeStep, setActiveStep] = useState(0);
    const [autoplayEnabled, setAutoplayEnabled] = useState(true);

    const handleStepChange = activeStep => {
        setActiveStep(activeStep);
    };

    const handleClick = () => {
        setAutoplayEnabled(false);
    };

    return (
        <>
            <AutoPlaySwipeableViews
                autoplay={autoplayEnabled}
                index={activeStep}
                onChangeIndex={handleStepChange}
                onClick={handleClick}
                enableMouseEvents
                interval={5000}>
                {BannerSteps.map((item, index) => {
                    return (
                        <BannerStep
                            step={index}
                            key={index}
                            src={item.src}
                            textPrimary={item.textPrimary}
                            textSecondary={item.textSecondary}
                            textDescription={item.textDescription}
                        />
                    );
                })}
            </AutoPlaySwipeableViews>
            <PaginationDots dots={BannerSteps.length} activeStep={activeStep} handleActiveStep={handleStepChange} />
        </>
    );
};

export default AuthCarousel;
